import { render, staticRenderFns } from "./Passwort.vue?vue&type=template&id=b1973ab6&"
import script from "./Passwort.vue?vue&type=script&lang=js&"
export * from "./Passwort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports